var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('visual-type-graph-squares',{attrs:{"position":"top","heading":"Extraversion","visual_types":_vm.visual_types,"total":_vm.total}}),_vm._v(" "),_c('visual-type-graph-squares',{attrs:{"position":"bottom","heading":"Introversion","visual_types":_vm.visual_types,"total":_vm.total}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }